<div class="flex flex-col bg-white rounded-lg border dark:border-none dark:bg-dark-panel"
  style="height: calc(100vh - 195px)">


  <div class="flex justify-between items-center p-2">
    <div class="animate-pulse bg-gray-300 dark:bg-gray-600 w-6 h-6 rounded"></div>
    <div class="animate-pulse bg-gray-300 dark:bg-gray-600 w-24 h-6 rounded"></div>
    <div class="animate-pulse bg-gray-300 dark:bg-gray-600 w-6 h-6 rounded"></div>
  </div>


  <div class="grid grid-cols-7 border-b">
    <div *ngFor="let day of [1,2,3,4,5,6,7]" class="py-2 text-center mx-1 rounded-md">
      <div class="animate-pulse bg-gray-300 dark:bg-gray-600 w-8 h-4 mx-auto rounded mb-1"></div>
      <div class="animate-pulse bg-gray-300 dark:bg-gray-600 w-6 h-4 mx-auto rounded"></div>
    </div>
  </div>

  <div
    class="p-0 overflow-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 dark:scrollbar-thumb-dark-panel dark:scrollbar-track-dark-background-alt flex-1 min-h-0">
    <ul class="h-full">
      <li class="h-full">
        <div class="bg-gray-50 overflow-hidden dark:bg-dark-panel h-full">
          <ul class="divide-y">
            <li *ngFor="let event of skeletonEvents" class="flex items-start py-2">


              <div class="w-12 max-w-12 h-full flex flex-col items-center justify-start relative pr-4">
                <div class="animate-pulse bg-gray-300 dark:bg-gray-600 w-8 h-3 rounded ml-3 mt-1"></div>
                <div *ngIf="event.id > 0" class="w-0.5 bg-gray-300 absolute left-1 top-0 bottom-full">
                </div>
              </div>

              <div class="bg-white dark:bg-dark-background-alt flex flex-row justify-between w-full">
                <div
                  class="flex flex-col flex-1 pl-4 border-l-2 border-red-500 bg-white py-2 dark:bg-dark-background-alt">

                  <div class="flex items-center mb-2">
                    <div class="animate-pulse bg-gray-300 dark:bg-gray-600 w-16 h-4 rounded mr-2">
                    </div>
                    <div class="animate-pulse bg-gray-300 dark:bg-gray-600 h-4 rounded"
                      [ngStyle]="{'width': event.titleWidth + '%'}"></div>
                  </div>


                  <div *ngIf="event.hasDescription" class="space-y-1 mb-2">
                    <div *ngFor="let width of event.descriptionWidths; let i = index"
                      class="animate-pulse bg-gray-300 dark:bg-gray-600 h-3 rounded" [ngStyle]="{'width': width}">
                    </div>
                  </div>


                  <div *ngIf="event.hasMultipleLines" class="space-y-1 mb-2">
                    <div class="animate-pulse bg-gray-300 dark:bg-gray-600 h-3 rounded w-3/4"></div>
                    <div class="animate-pulse bg-gray-300 dark:bg-gray-600 h-3 rounded w-1/2"></div>
                  </div>


                  <div *ngIf="event.hasLink" class="animate-pulse bg-blue-300 dark:bg-blue-600 w-24 h-3 rounded"></div>

                </div>


                <div class="flex items-center pr-2">
                  <div class="animate-pulse bg-gray-300 dark:bg-gray-600 w-6 h-6 rounded"></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
